import { gql } from '@apollo/client';

export const COMMIT_FIND_SYNC_MUTATION = gql`
  mutation CommitFindSync(
    $siteId: ID
    $findId: ID
    $input: FindSyncCommitInput
  ) {
    commitFindSync(siteId: $siteId, findId: $findId, input: $input) {
      createdAcolyte
      updatedAcolyte
      createdSheet
      updatedSheet
      failures {
        key
        message
      }
    }
  }
`;
